import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/option-item/option-item.component.js'

const tagName = 'dap-ds-option-item'

/**
 * `dap-ds-option-item`
 * @summary An option item is a selectable item in a list of options.
 * @element dap-ds-option-item
 * @title - Option item
 * @group select,combobox
 * *
 * @csspart base - The main option item container.
 * @csspart prefix - The prefix of the option item.
 * @csspart label - The label of the option item.
 * @csspart suffix - The suffix of the option item.
 *
 * @slot prefix - The prefix of the option item.
 * @slot - The label of the option item.
 * @slot suffix - The suffix of the option item.
 *
 * @cssproperty --dds-option-item-padding-vertical - The vertical padding of the option item.
 * @cssproperty --dds-option-item-padding-horizontal - The horizontal padding of the option item.
 * @cssproperty --dds-option-item-border-radius - The border radius of the option item.
 * @cssproperty --dds-option-item-color - The text color of the option item.
 * @cssproperty --dds-option-item-hover-bg - The background color of the option item when hovered.
 * @cssproperty --dds-option-item-active-bg - The background color of the option item when active.
 * @cssproperty --dds-option-item-disabled-color - The text color of the option item when disabled.
 * @cssproperty --dds-option-item-high-contrast-border - The border color of the option item in high contrast mode.
 * @cssproperty --dds-option-item-selected-font-weight - The font weight of the option item when selected.
 * @cssproperty --dds-option-item-xs-font-size - The font size of the option item in extra small size.
 * @cssproperty --dds-option-item-lg-font-size - The font size of the option item in large size.
 * @cssproperty --dds-option-item-selected-icon-width - The width of the selected icon.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSOptionItem',
})

export default reactWrapper
